<template>
    <div class="container pt-4 mb-5 lower-width">
        <div class="card shadow-sm ps-border">
            <div class="card-header">
                <kt-row>
                    <kt-col lg="3" md="3" xs="12" class="text-center">
                        <img v-if="form_data.profile_image"
                             width="100"
                             height="100"
                             :src="form_data.profile_image"
                             alt="profile"

                        >
                        <img v-else
                             width="100"
                             height="100"
                             src="https://img.icons8.com/bubbles/100/000000/user.png"
                             :alt="form_data.user_full_name"
                        >
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12" id="info_col">
                        <p class="pay-to">{{ $t('pardakht_shakhsi.p.pay_to') }}</p>
                        <h3 class="user_name">{{ form_data.full_name }}</h3>
                        <div v-if="form_data.show_phone_number" class="phone_number">
                            {{ $t('pardakht_shakhsi.p.phone_number') }}
                            <span class="phone">{{ form_data.phone_number }}</span>
                        </div>
                        <p class="description mt-2" style="text-align: center">{{ form_data.description }}</p>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <div class="paystar-logo ">
                            <img
                                    :src=" form_data.site_logo"
                                    :alt="form_data.site_name"
                                    style="max-width: 100px; max-height:100px"
                            >
                        </div>
                    </kt-col>
                </kt-row>
            </div>
            <div class="card-body">
                <p class="ps-description">
                    {{ $t('pardakht_shakhsi.p.form_description') }}
                </p>
                <form @submit.prevent="submit" id="payment_form">
                    <kt-form-section>
                        <kt-row>
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('pardakht_shakhsi.form.label.price') }}
                                    </kt-form-label>
                                    <currency-input
                                            dir="rtl"
                                            :currency="{
                                                suffix: ' ' + $t('currency.rial') + ' ',
                                                prefix: ''
                                            }"
                                            v-model="direct_form_data.amount"
                                            :precision="0"
                                            :value-as-integer="true"
                                            :value-range="{max:495000000}"
                                            :allow-negative="false"
                                            id="amount"
                                            name="amount"
                                            class="form-input form-control"
                                            :placeholder="$t('pardakht_shakhsi.form.placeholder.rial_amount')"
                                    >
                                    </currency-input>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                        <kt-row>
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('pardakht_shakhsi.form.label.full_name') }}
                                    </kt-form-label>
                                    <div class="kt-input-icon kt-input-icon--right">
                                        <kt-form-control
                                                id="payer_name"
                                                name="payer_name"
                                                class="form-input"
                                                v-model="direct_form_data.payer_name"
                                        >
                                        </kt-form-control>
                                        <span class="kt-input-icon__icon kt-input-icon__icon--right form-spn">
                                            <span>{{ $t('pardakht_shakhsi.form.span.optional') }}</span>
                                        </span>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('pardakht_shakhsi.form.label.email') }}
                                    </kt-form-label>
                                    <div class="kt-input-icon kt-input-icon--right">
                                        <kt-form-control
                                                dir="ltr"
                                                id="payer_email"
                                                name="payer_email"
                                                class="form-input"
                                                v-model="direct_form_data.payer_email"
                                        >
                                        </kt-form-control>
                                        <span class="kt-input-icon__icon kt-input-icon__icon--right form-spn">
                                            <span>{{ $t('pardakht_shakhsi.form.span.optional') }}</span>
                                        </span>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('pardakht_shakhsi.form.label.phone_number') }}
                                    </kt-form-label>
                                    <div class="kt-input-icon kt-input-icon--right ">
                                        <kt-form-control
                                                id="payer_phone_number"
                                                name="payer_phone_number"
                                                class="form-input"
                                                type="number"
                                                v-model="direct_form_data.payer_phone_number"
                                        >
                                        </kt-form-control>
                                        <span class="kt-input-icon__icon kt-input-icon__icon--right form-spn">
                                            <span style="color: red">
                                                {{ $t('pardakht_shakhsi.form.span.required') }}
                                            </span>
                                        </span>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('pardakht_shakhsi.form.label.description') }}
                                    </kt-form-label>
                                    <div class="kt-input-icon kt-input-icon--right">
                                        <kt-form-control
                                                id="payer_description"
                                                name="payer_description"
                                                class="form-input"
                                                v-model="direct_form_data.payer_description"
                                        >
                                        </kt-form-control>
                                        <span class="kt-input-icon__icon kt-input-icon__icon--right form-spn">
                                            <span>{{ $t('pardakht_shakhsi.form.span.optional') }}</span>
                                        </span>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </kt-form-section>
                    <input type="hidden" name="username" id="username" v-model="direct_form_data.username = form_data.username">
                    <kt-form-action class="mt-2 mb-2 text-center">
                        <kt-button
                                class="m-2 form-submit p-3 pr-5 pl-5"
                                size="md"
                                variant="success"
                                type="submit"
                                v-bind:wide="true"
                                id="submit_btn"
                        >
                            {{ $t('pardakht_shakhsi.form.btn.pay') }}
                            <i class="fa fa-credit-card ml-3"></i>
                        </kt-button>
                    </kt-form-action>
                </form>
                <div class="w-200 text-center mt-2" id="qr"></div>
            </div>
        </div>
    </div>
</template>

<script>

import QrCodeWithLogo from 'qr-code-with-logo'
// import LocalImage from "@/assets/media/logoemail.png";

export default {
    name: "directForm",
    props: {
        submit: {
            default: () => {},
            type: Function
        },
        form_data: {
            default() {
                return {}
            }
        },
        direct_form_data: {
            default() {
                return {}
            }
        },
        price: {
            default() {
                return null
            }
        }
    },
    data() {
        return {
            pardakhtShakhsiLink: window.location.origin + '/d/@' + this.form_data.username
        }
    },
    computed: {
        qr_canvas() {
            const qr_canvas = document.createElement('canvas')
            document.getElementById('qr').appendChild(qr_canvas)

            return qr_canvas
        }
    },
    watch: {
        form_data: function (form_data) {
            if(form_data.username) {
                this.createQrCode()
            }
        }
    },
    methods: {
        createQrCode() {
            QrCodeWithLogo.toCanvas({
                canvas: this.qr_canvas,
                content: this.pardakhtShakhsiLink,
                width: 200,
                height: 200,
                logo: {
                    // src: LocalImage,
                    src: this.form_data.QR_logo,
                    borderRadius: '20',
                    bgColor: '#fff',
                    logoSize: 0.25,
                    borderSize: 0
                }
            })
        },
        checkIfPriceSet() {
            if (this.price) {
                this.direct_form_data.amount = this.price;
            }
        }
    },
    mounted() {
        this.checkIfPriceSet()
        this.createQrCode()
    }
}
</script>

<style scoped>
    .ps-border {
        border: 1px solid transparent;
        -o-border-image: linear-gradient(
                135deg,rgba(0,190,165,1) 0%,
                rgba(255,255,255,1) 24%,
                rgba(0,190,165,1) 40%,
                rgba(255,255,255,1) 60%,
                rgba(0,190,165,1) 79%,
                rgba(255,255,255,1) 92%);
        border-image: linear-gradient(
                135deg,rgba(0,190,165,1) 0%,
                rgba(255,255,255,1) 24%,
                rgba(0,190,165,1) 40%,
                rgba(255,255,255,1) 60%,
                rgba(0,190,165,1) 79%,
                rgba(255,255,255,1) 92%);
        border-image-slice: 2;
    }
    .lower-width {
        max-width: 650px;
    }
    .user-img img {
        width: 100px;
    }
    #info_col{
        text-align: center;
    }
    .pay-to, .phone_number {
        font-size: 1.3rem;
    }
    .user_name {
        color: #00bea5;
    }
    .phone {
        color: #ee3525;
    }
    .paystar-logo {
        margin: auto;
        text-align: center;
    }
    .paystar-logo img {
        width: 100%;
    }
    #amount {
        font-size: 3rem;
        color: #00bea5;
        text-align: center;
    }
    .form-spn {
        font-size: 1rem;
        padding-left: 10px;
    }
    .form-input {
        font-size: 1.4rem;
        padding-left: 4.1rem!important;
    }
    .form-submit {

    }


    @media screen and (max-width: 440px){
        .user-img img {
            width: 100%;
        }
    }
    @media screen and (max-width: 767px){
        .paystar-logo {
            padding-top: 10px;
            border-top: #00bea5 2px dashed;
        }
        .paystar-logo img {
            width: 150px;
        }
    }
</style>